<script>
	import { sTema } from '../../stores';

	export let dados = {};
	export let parametros = {
		descricaoHtml: false,
		permitirSelecaoDescricao: false
	};
</script>

<style>
	.box {
		transition: all 1.5s cubic-bezier(.25, .8, .25, 1);
		margin-bottom: 15px;
		-webkit-user-select: none; /* Safari */        
		-moz-user-select: none; /* Firefox */
		-ms-user-select: none; /* IE10+/Edge */
		user-select: none; /* Standard */
		break-inside: avoid-column;
		border:3px solid #fff;
	}

	.box:hover {
		border:3px solid #7700b8;
	}

	.borda-noite {
		border: 3px solid #aaa;
	}

	.cor-titulo-noite {
		color: #cc6bff;
	}
</style>

<div class="box {$sTema == "dia" ? "" : "has-background-dark borda-noite"}">
	{#if dados.tag != null} 
		<span class="tag is-primary is-pulled-right">{ dados.tag }</span>
	{/if}
	
	<h1 class="is-size-4 has-text-primary">
		<strong class="{$sTema == "dia" ? "has-text-primary" : "cor-titulo-noite"} {parametros.permitirSelecaoDescricao == true ? 'permitir-selecao' : ''}">{dados.titulo}</strong>
	</h1>
	
	{#if parametros.descricaoHtml == true}
		<div class="{$sTema == "dia" ? "" : "has-text-white"}">
			{@html dados.descricao}
		</div>
	{:else}
		<span class="is-size-6 has-text-grey {parametros.permitirSelecaoDescricao == true ? 'permitir-selecao' : ''}">
			{dados.descricao}
		</span>
	{/if}
	
	{#if dados.acoes}
	<br>

	<div class="is-inline-flex mt-2">
		<strong class="{$sTema == "dia" ? "" : "has-text-white"}">Ações: </strong>&nbsp;
		{#each dados.acoes as link, i}
			<a href="{link.url}">{link.texto}</a>
			{#if ++i < dados.acoes.length} 
				&nbsp; &bull; &nbsp;
			{/if}
		{/each}
	</div>
	{/if}
</div>